var _path, _path2, _g, _g2, _circle, _ellipse, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNinguem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 305,
    viewBox: "0 0 300 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.752 269.53C305.987 255.211 285.308 183.615 141.923 183.615C38.4274 183.615 -9.07413 242.218 1.42751 271.917",
    fill: "url(#paint0_radial_924_402)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_924_402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 183,
    width: 300,
    height: 89
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.752 269.53C305.987 255.211 285.308 183.615 141.923 183.615C38.4274 183.615 -9.07413 242.218 1.42751 271.917",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_924_402)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 119.807,
    cy: 223.765,
    rx: 7.88551,
    ry: 4.38001,
    fill: "url(#paint1_linear_924_402)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 200.293,
    cy: 217.079,
    rx: 12.4416,
    ry: 6.83282,
    fill: "url(#paint2_linear_924_402)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 58.7033,
    cy: 198.857,
    rx: 12.4416,
    ry: 6.83282,
    fill: "url(#paint3_linear_924_402)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.320685
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.689,
    cy: 64.1958,
    rx: 8.41121,
    ry: 8.40963,
    fill: "url(#paint4_linear_924_402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.413 57.5271C223.803 57.0182 221.164 57.4171 220.668 58.7779C219.874 60.9602 224.892 64.7896 231.876 67.3312C238.861 69.8728 245.167 70.1642 245.961 67.982C246.461 66.6089 244.17 64.6878 241.026 62.7416",
    fill: "#764BA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.413 57.5271C223.803 57.0182 221.164 57.4171 220.668 58.7779C219.874 60.9602 224.892 64.7896 231.876 67.3312C238.861 69.8728 245.167 70.1642 245.961 67.982C246.461 66.6089 244.17 64.6878 241.026 62.7416",
    stroke: "#280948",
    strokeWidth: 4.20561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.118 64.1958C241.118 59.5513 237.352 55.7861 232.706 55.7861C228.061 55.7861 225.151 58.7556 224.551 62.1039C224.551 62.1039 229.386 65.1308 231.619 65.7814C232.331 65.9889 233.037 66.2581 233.755 66.4967C234.559 66.7636 235.378 66.999 236.206 67.2033C236.773 67.343 237.551 67.5591 238.276 67.694C239.233 67.8719 240.09 67.9513 240.157 67.9513C240.276 67.9513 240.406 67.4226 240.674 66.8064C240.941 66.1902 241.118 64.1958 241.118 64.1958Z",
    fill: "url(#paint5_linear_924_402)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.418364,
    cx: 47.8839,
    cy: 113.808,
    r: 9.80769,
    fill: "url(#paint6_linear_924_402)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 154.039,
    cy: 197.462,
    rx: 29.4231,
    ry: 8.07692,
    fill: "url(#paint7_linear_924_402)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 31.1409L146.013 32.3248L85.8302 197.675C85.5032 198.573 84.51 199.036 83.6118 198.709V198.709C82.7136 198.382 82.2504 197.389 82.5774 196.491L142.76 31.1409Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.677 31.2207L168.22 48.0498C170.32 49.4332 172.665 50.4015 175.129 50.9022V50.9022C188.465 53.6118 197.159 66.5207 194.657 79.8968L188.624 112.155C188.596 112.305 188.383 112.309 188.347 112.162V112.162C185.547 100.871 174.895 93.2702 163.314 94.3633V94.3633C158.038 94.8612 152.8 93.0807 148.921 89.4702L128.421 70.3911L142.677 31.2207Z",
    fill: "#280948"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.108,
    cy: 30.6648,
    r: 2.30769,
    transform: "rotate(20 144.108 30.6648)",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.463 130.034C105.463 130.034 107.194 129.168 107.194 129.457C107.194 129.745 107.194 132.918 107.194 132.918L106.04 133.495L105.463 130.034Z",
    fill: "#FFE9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.242 187.813C138.242 187.813 137.66 185.691 136.129 185.554C134.598 185.416 130.284 189.979 129.383 191.863C128.481 193.747 130.944 196.388 133.756 193.85C136.567 191.312 138.242 187.813 138.242 187.813Z",
    fill: "#8CA4D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.045 194.003L138.286 189.097C137.578 187.121 134.886 186.869 133.824 188.68V188.68C133.612 189.041 133.495 189.447 133.501 189.866C133.53 191.85 133.854 197.853 136.667 198.662C140.045 199.634 140.045 194.003 140.045 194.003Z",
    fill: "url(#paint8_linear_924_402)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.75 187.813C161.75 187.813 162.332 185.691 163.863 185.554C165.394 185.416 169.708 189.979 170.609 191.863C171.511 193.747 169.048 196.388 166.236 193.85C163.425 191.312 161.75 187.813 161.75 187.813Z",
    fill: "#8CA4D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.95 194.004L161.708 189.097C162.416 187.121 165.108 186.87 166.17 188.68V188.68C166.382 189.042 166.5 189.447 166.493 189.866C166.464 191.851 166.14 197.853 163.327 198.663C159.95 199.635 159.95 194.004 159.95 194.004Z",
    fill: "url(#paint9_linear_924_402)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.54 179.268C140.54 179.268 139.575 181.163 139.575 182.496C138.61 184.657 137.021 187.565 134.268 193.631C132.464 197.605 135.717 198.659 138.174 198.913C139.709 199.072 141.179 198.436 142.372 197.458L149.735 191.423L158.497 198.658C160.086 199.971 162.386 199.962 163.965 198.637V198.637C165.589 197.274 166.013 194.902 165.077 193C164.026 190.862 162.464 187.514 160.323 182.496C160.323 181.177 159.481 179.913 159.481 179.913L140.54 179.268Z",
    fill: "url(#paint10_linear_924_402)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.539 164.269C163.113 166.568 162.693 172.316 162.693 172.316H158.077L159.921 184.71C160.011 185.313 159.675 185.896 159.102 186.105C157.039 186.86 152.153 188.537 149.008 188.723C145.855 188.91 140.502 187.276 138.245 186.529C137.635 186.327 137.29 185.708 137.46 185.088C137.952 183.296 139.252 179.203 142.362 172.316C143.325 173.443 137.885 172.316 137.885 172.316C137.885 172.316 138.225 167.198 139.616 164.269C141.007 161.341 144.231 159.385 144.231 159.385L152.384 158.146C152.384 158.146 155.77 158.808 157.5 159.73C159.231 160.652 159.965 161.97 161.539 164.269Z",
    fill: "#764BA2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.255 172.294L162.072 177.762L161.452 180.498L157.192 198.073L157.871 199.539L158.31 201.443L157.871 202.655L156.717 202.224L154.41 200.347L153.994 199.101C153.891 198.792 153.924 198.454 154.084 198.171L155.215 196.16L158.31 179.752L157.999 172.501L162.255 172.294Z",
    fill: "#FDE7E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.001 172.5L138.499 177.761L139.118 180.497L143.379 198.073L142.699 199.539L142.26 201.443L142.699 202.654L143.853 202.224L146.161 200.347L146.576 199.101C146.679 198.792 146.647 198.454 146.487 198.17L145.356 196.16L142.26 179.751L142.501 172.5L138.001 172.5Z",
    fill: "#FDE7E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.89 153.672H147.346V159.762H151.89V153.672ZM149.163 163.248C149.163 162.384 147.346 159.763 147.346 159.763H151.89C151.89 159.763 149.163 164.113 149.163 163.248Z",
    fill: "#FECECD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.355,
    cy: 152.664,
    rx: 4.02909,
    ry: 6,
    fill: "#FFE9E9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.933 153.664C145.255 152.52 145.255 149.998 145.9 149.916C146.544 149.834 147.834 150.311 149.123 149.385C149.768 148.876 150.09 148.813 150.09 148.557C153.313 149.166 151.386 151.002 152.991 153.026C153.158 153.237 153.636 153.026 153.636 153.026C153.636 153.026 153.636 148.044 153.313 147.6C152.991 147.155 151.702 145.365 151.057 146.642C151.057 146.004 149.768 145.345 148.478 145.834C147.189 146.323 145.255 147.28 144.933 148.557C144.61 149.834 144.288 152.387 144.933 153.664Z",
    fill: "#513450"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_924_402",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.111 214.238) rotate(-90) scale(51.3403 536.198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_924_402",
    x1: 113.46,
    y1: 222.604,
    x2: 115.863,
    y2: 227.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_924_402",
    x1: 189.846,
    y1: 216.44,
    x2: 194.242,
    y2: 225.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_924_402",
    x1: 50.7703,
    y1: 198.968,
    x2: 53.2577,
    y2: 208.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_924_402",
    x1: 221.198,
    y1: 58.4049,
    x2: 225.404,
    y2: 72.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#280948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717538,
    stopColor: "#764BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6A8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_924_402",
    x1: 229.596,
    y1: 63.472,
    x2: 232.346,
    y2: 69.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#764BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6A8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_924_402",
    x1: 60.7777,
    y1: 116.719,
    x2: 50.9843,
    y2: 100.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#280948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#764BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C6A8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_924_402",
    x1: 131.953,
    y1: 198.419,
    x2: 148.48,
    y2: 224.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_924_402",
    x1: 140.045,
    y1: 198.805,
    x2: 140.045,
    y2: 185.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_924_402",
    x1: 159.95,
    y1: 198.806,
    x2: 159.95,
    y2: 185.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667EEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_924_402",
    x1: 165.62,
    y1: 199.606,
    x2: 165.62,
    y2: 179.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#667EEA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinguem);
export default __webpack_public_path__ + "static/media/ninguem.dcdd471d26806b55a10327a5fb123f0c.svg";
export { ForwardRef as ReactComponent };